module.exports = __webpack_public_path__ + "img/voucher_sportglide_weekend.322f811f.jpg";